import React, { useState, useEffect } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import './navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`gpt3__navbar${scrolled ? ' gpt3__navbar--scrolled' : ''}`}>
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <span className="gpt3__navbar-brand">FitnessHub</span>
        </div>
        <div className="gpt3__navbar-links_container">
          <p><a href="#home">Home</a></p>
          <p><a href="#wgpt3">About Us</a></p>
          <p><a href="#services">Services</a></p>
          <p><a href="#features">Features</a></p>
          <p><a href="#contact">Contact</a></p>
        </div>
      </div>
      <div className="gpt3__navbar-sign">
        {/* <Link to="/admin/login"><p>Admin</p></Link> */}
        <Link to="/contact">
          <button type="button">Connect Now</button>
        </Link>
      </div>
      <div className="gpt3__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
          <div className="gpt3__navbar-menu_container scale-up-center">
            <div className="gpt3__navbar-menu_container-links">
              <p><a href="#home" onClick={() => setToggleMenu(false)}>Home</a></p>
              <p><a href="#wgpt3" onClick={() => setToggleMenu(false)}>About Us</a></p>
              <p><a href="#services" onClick={() => setToggleMenu(false)}>Services</a></p>
              <p><a href="#features" onClick={() => setToggleMenu(false)}>Features</a></p>
              <p><a href="#contact" onClick={() => setToggleMenu(false)}>Contact</a></p>
            </div>
            <div className="gpt3__navbar-menu_container-links-sign">
              <Link to="/admin/login"><p>Admin</p></Link>
              <Link to="/contact">
                <button type="button" onClick={() => setToggleMenu(false)}>Connect Now</button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;